import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePortalAuth } from '../../context/PortalAuthContext';

const PortalAuthCallback = () => {
  const { loginWithGoogleSession } = usePortalAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      setError('Missing session information — please try signing in again.');
      return;
    }
    loginWithGoogleSession(match[1])
      .then(() => navigate('/portal'))
      .catch(() => setError('Google sign-in failed — please try again.'));
  }, []);

  return (
    <div className="min-h-screen bg-[#FFFBF5] flex items-center justify-center px-6">
      <div className="text-center">
        {error ? (
          <>
            <p className="text-red-600 font-semibold mb-3">{error}</p>
            <button onClick={() => navigate('/login')} className="text-[#4F46E5] font-semibold underline">Back to sign in</button>
          </>
        ) : (
          <p className="text-stone-500">Signing you in…</p>
        )}
      </div>
    </div>
  );
};

export default PortalAuthCallback;
